// Javascript for a form where password is entered and changed in the charity admin system.
// Takes care of admin account activation, forgot password and change password processes.

import Form from "Scripts/common/form";
import PasswordRequirements from 'Scripts/common/password-requirements';

export default class SetPassword {
	constructor() {
		this.form = new Form({
			callback:     this.afterPost.bind(this),
			form:         $("#form-password"),
			willRedirect: true,
		});

		new PasswordRequirements({input: $("#password")});
	}

	afterPost(response) {
		console.log("SetPassword.afterPost", response?.payload?.redirectUrl || (response.success ? '/' : window.location));
		window.location.href = response?.payload?.redirectUrl || (response.success ? '/' : window.location);
	}
};
